import { useFormContext } from 'old-rhf';

import {
  getFieldError,
  InputGroupBase,
  InputGroupBaseItems,
  InputGroupBaseProps,
  CardInputBase,
  CheckboxBase,
  RadioBase,
  FCC
} from '@zazume/zzm-base';

interface InputGroupProps extends Omit<InputGroupBaseProps, 'error'> {}

/**
 * @deprecated This component will be removed after the RHF migration is complete. Use the ZZMForm equivalent from @zazume/zzm-base instead.
 */
export const InputGroup: FCC<InputGroupProps> & InputGroupBaseItems = props => {
  const {
    register,
    formState: { errors }
  } = useFormContext();

  const error = getFieldError(props.name, errors);

  return <InputGroupBase {...props} ref={register} error={error} />;
};

InputGroup.RadioInput = RadioBase;
InputGroup.CheckboxInput = CheckboxBase;
InputGroup.CardInput = CardInputBase;
